import { FillInputByLabelInstruction } from '../FillInputByLabelInstruction'

export class FullAddressInstruction extends FillInputByLabelInstruction {
  constructor ({ label, waitForNoLoaders, value }) {
    super({
      name: 'FullAddress',
      label,
      waitForNoLoaders,
      value

    })
  }

  setDefaultValue (params) {
    this.value = params.addressInformation.userAddress
  }
}
